/**
 * Prüfung beim Verlassen eines Felds (Baustein A, Ticket 1.256): Ein Formular ruft beim Verlassen genau die Prüfung
 * auf, die es auch beim Speichern nutzt, und übernimmt daraus nur den Satz dieses einen Felds. So gibt es keine zweite
 * Prüfregel im Client; der Satz unter dem Feld ist derselbe wie beim Speichern.
 *
 * Regeln:
 * - Feld unverändert (leer betreten und verlassen, alten Wert stehen lassen): keine neue Meldung, eine alte Meldung
 *   dieses Felds verschwindet.
 * - Feld geändert: Satz aus der Speicher-Prüfung (`saveErrors[key]`); hat die Prüfung für das Feld nichts, verschwindet
 *   die Meldung.
 * - Meldungen anderer Felder bleiben unberührt.
 *
 * Reine Funktion; gibt bei keiner Änderung dasselbe Objekt zurück (spart ein Neuzeichnen).
 */
export function blurError<E extends Readonly<Record<string, string>>>(
  errors: E,
  key: string,
  { changed, saveErrors }: { changed: boolean; saveErrors: Readonly<Record<string, string>> },
): E {
  const next = changed ? saveErrors[key] : undefined;
  if (errors[key] === next) return errors;
  const out: Record<string, string> = { ...errors };
  if (next === undefined) delete out[key];
  else out[key] = next;
  return out as E;
}
